<script setup>
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useElementSize } from '@vueuse/core';
import BackButton from '../BackButton.vue';
import InboxName from '../InboxName.vue';
import MoreActions from './MoreActions.vue';
// BonBoZ: nut bat/tat bot test cho tung hoi thoai — TAM AN (user chot
// 10/09/2026), giu code de bat lai khi can che do khep kin.
import BotTestToggle from './BotTestToggle.vue';
// BonBoZ: nut giao lai hoi thoai cho chatbot, ban gon (chi icon).
// BonBoZ: bang gan the cho dien thoai — xem BangGanThe.vue.
import BangGanThe from './BangGanThe.vue';
import { useTheHoiThoai } from 'dashboard/composables/useTheHoiThoai';
import Avatar from 'next/avatar/Avatar.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import SLACardLabel from './components/SLACardLabel.vue';
import ConversationCallButton from './ConversationCallButton.vue';
import wootConstants from 'dashboard/constants/globals';
import { conversationListPageURL } from 'dashboard/helper/URLHelper';
import { snoozedReopenTime } from 'dashboard/helper/snoozeHelpers';
import { useInbox } from 'dashboard/composables/useInbox';
import { usePanelKhach } from 'dashboard/composables/usePanelKhach';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
// BonBoZ: cỡ avatar là prop số nên phải tính bằng JS, không có class Tailwind nào thay được.
import { usePancakeMetrics } from 'dashboard/composables/usePancakeMetrics';

const props = defineProps({
  chat: {
    type: Object,
    default: () => ({}),
  },
  showBackButton: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
const store = useStore();
const route = useRoute();

// BonBoZ: MOT nut bot duy nhat — xem BotTestToggle.vue.
//
// Truoc day co HAI nut cung icon con bot ma chuc nang khac nhau, nguoi dung bam
// nham; ban vaday an bot ANH mot cai di. Nhung an di khong giai quyet duoc goc:
// bot chi noi khi CA BA cong cung mo, ma moi nut chi mo mot phan, nen bam dung
// nut con lai van khong du.
//
// 13/09/2026 gop lam mot: BotTestToggle nay lam ca ba viec. Nut kia xoa han khoi
// ma nguon, khong giu lai duoi co an — giu code chet thi lan sau lai co nguoi bat
// no len va hai nut lai cung ton tai.
const conversationHeader = ref(null);
const { width } = useElementSize(conversationHeader);
const { isAWebWidgetInbox } = useInbox();
const { headerAvatarSize } = usePancakeMetrics();

// BonBoZ: icon nhom nguoi mo/dong sidebar phai - Pancake cung dat no o day.
// BonBoZ: dien thoai giu trang thai rieng trong phien, khong ghi de cau hinh
// dung chung voi may tinh. Xem `composables/usePanelKhach.js`.
const { batTat: toggleSidebar, laDienThoai } = usePanelKhach();

// BonBoZ: nut GAN THE, chi tren dien thoai. May tinh da co luoi the duoi khung
// chat (ComposerTagGrid); tren dien thoai luoi do an ba hang man hinh nen
// Pancake dua vao day. Huy hieu dem so the dang gan de khong phai mo ra moi
// biet hoi thoai da duoc gan gi chua.
const { soTheDaGan } = useTheHoiThoai();
const bangTheDangMo = ref(false);

const currentChat = computed(() => store.getters.getSelectedChat);

// NUT BOT CHI HIEN TREN TRANG DA NOI BOT (user chot 17/09/2026).
//
// Truoc day nut hien tren MOI hoi thoai, ke ca trang chua ai noi bot bao gio. Bam
// nhau vao do thi bot khong tra loi ma nguoi truc lai tuong hong; con tren trang
// khach THAT thi mot cu bam nham la bot nhan tin thang cho khach.
//
// DOC THANG CAU HINH BOT CO SAN cua Chatwoot (Cai dat hop thu > Cau hinh Bot),
// KHONG dung mot co rieng. Dat co rieng la hai nguon su that cho cung mot cau hoi
// 'trang nay co bot chua' — chung se lech nhau, va nguoi dung phai nho bat o HAI
// cho moi chay.
//
// `getActiveAgentBot` tra ve `{}` khi chua noi bot, nen phai xet `.id` chu khong
// xet truthiness cua ca object — object rong van la truthy.
const botCuaTrang = computed(() =>
  store.getters['agentBots/getActiveAgentBot'](currentChat.value?.inbox_id)
);
const hienNutBot = computed(() => Boolean(botCuaTrang.value?.id));

// Kho `agentBots` can HAI thu: danh sach bot cua account, va anh xa trang -> bot.
// `getActiveAgentBot` tra cuu danh sach bang id lay tu anh xa, thieu mot trong hai
// la luon ra rong.
//
// Nap lai moi khi doi hoi thoai sang TRANG KHAC. Vuex phan hoi thay doi, nen noi
// hay ngat bot ben Cai dat la nut o day tu an/hien — khong phai tai lai trang.
watch(
  () => currentChat.value?.inbox_id,
  inboxId => {
    if (!inboxId) return;
    store.dispatch('agentBots/get');
    store.dispatch('agentBots/fetchAgentBotInbox', inboxId);
  },
  { immediate: true }
);
const accountId = computed(() => store.getters.getCurrentAccountId);

const chatMetadata = computed(() => props.chat.meta);

const backButtonUrl = computed(() => {
  const {
    params: { inbox_id: inboxId, label, teamId, id: customViewId },
    name,
  } = route;

  const conversationTypeMap = {
    conversation_through_mentions: 'mention',
    conversation_through_participating: 'participating',
    conversation_through_unattended: 'unattended',
  };
  return conversationListPageURL({
    accountId: accountId.value,
    inboxId,
    label,
    teamId,
    conversationType: conversationTypeMap[name],
    customViewId,
  });
});

const isHMACVerified = computed(() => {
  if (!isAWebWidgetInbox.value) {
    return true;
  }
  return chatMetadata.value.hmac_verified;
});

const currentContact = computed(() =>
  store.getters['contacts/getContact'](props.chat.meta.sender.id)
);

const isSnoozed = computed(
  () => currentChat.value.status === wootConstants.STATUS_TYPE.SNOOZED
);

const snoozedDisplayText = computed(() => {
  const { snoozed_until: snoozedUntil } = currentChat.value;
  if (snoozedUntil) {
    return `${t('CONVERSATION.HEADER.SNOOZED_UNTIL')} ${snoozedReopenTime(snoozedUntil)}`;
  }
  return t('CONVERSATION.HEADER.SNOOZED_UNTIL_NEXT_REPLY');
});

const inbox = computed(() => {
  const { inbox_id: inboxId } = props.chat;
  return store.getters['inboxes/getInbox'](inboxId);
});

const hasMultipleInboxes = computed(
  () => store.getters['inboxes/getInboxes'].length > 1
);

const hasSlaPolicyId = computed(
  () => props.chat?.applied_sla?.id && !currentContact.value?.blocked
);

// BonBoZ: dong "<ai> da xem - <gio>" cua Pancake. Du lieu da co san trong store
// (`agent_last_seen_at` + assignee), khong goi them API nao.
const daXem = computed(() => {
  const at = currentChat.value?.agent_last_seen_at;
  if (!at) return '';
  const gio = new Date(at * 1000).toLocaleTimeString('vi-VN', {
    hour: '2-digit',
    minute: '2-digit',
  });
  const ai = currentChat.value?.meta?.assignee?.name;
  return ai
    ? t('BONBOZ.TIN_NHAN.DA_XEM', { ai, gio })
    : t('BONBOZ.TIN_NHAN.DA_XEM_AN_DANH', { gio });
});

const copyConversationId = async () => {
  try {
    await copyTextToClipboard(String(props.chat.id));
    useAlert(t('CONVERSATION.HEADER.COPY_ID_SUCCESS'));
  } catch (error) {
    // error
  }
};
</script>

<template>
  <!-- BonBoZ: header ba dong kieu Pancake - ten / ai da xem / icon nho; cao co theo man hinh. -->
  <div
    ref="conversationHeader"
    class="flex items-center justify-between flex-1 w-full min-w-0 gap-2 px-3 h-[54px] md:h-[62px] 2xl:h-[69px] 3xl:h-[76px] shrink-0"
  >
    <div class="flex items-center justify-start min-w-0 flex-1">
      <BackButton
        v-if="showBackButton"
        :back-url="backButtonUrl"
        class="ltr:mr-2 rtl:ml-2"
      />
      <Avatar
        :name="currentContact.name"
        :src="currentContact.thumbnail"
        :size="headerAvatarSize"
        :status="currentContact.availability_status"
        hide-offline-status
      />
      <div
        class="flex flex-col items-start min-w-0 ml-2 overflow-hidden rtl:ml-0 rtl:mr-2"
      >
        <div class="flex flex-row items-center max-w-full gap-1 p-0 m-0">
          <span
            class="text-sm font-bold truncate leading-tight text-n-slate-12"
          >
            {{ currentContact.name }}
          </span>
          <fluent-icon
            v-if="!isHMACVerified"
            v-tooltip="$t('CONVERSATION.UNVERIFIED_SESSION')"
            size="14"
            class="text-n-amber-10 my-0 mx-0 min-w-[14px] flex-shrink-0"
            icon="warning"
          />
        </div>

        <div
          class="flex items-center gap-1 overflow-hidden text-xs conversation--header--actions text-n-slate-11 text-ellipsis whitespace-nowrap"
        >
          <span v-if="daXem" class="truncate">{{ daXem }}</span>
          <template v-if="hasMultipleInboxes">
            <span v-if="daXem">•</span>
            <InboxName :inbox="inbox" class="!mx-0" />
          </template>
          <span v-if="isSnoozed">•</span>
          <span v-if="isSnoozed" class="font-medium text-n-amber-10">
            {{ snoozedDisplayText }}
          </span>
        </div>

        <!-- BonBoZ: dong icon nho. Chi giu icon co hanh vi that - "lich su" va
             "emoji" cua Pancake chua co gi tuong ung ben Chatwoot. -->
        <div class="flex items-center gap-1 -ml-1">
          <NextButton
            v-tooltip="$t('CONVERSATION.HEADER.COPY_ID_SUCCESS')"
            xs
            ghost
            slate
            icon="i-lucide-link"
            :aria-label="`#${chat.id}`"
            @click="copyConversationId"
          />
        </div>
      </div>
    </div>
    <div
      class="flex flex-row items-center justify-end flex-shrink-0 gap-1 header-actions-wrap"
    >
      <SLACardLabel
        v-if="hasSlaPolicyId"
        :chat="chat"
        show-extended-info
        :parent-width="width"
        class="hidden md:flex"
      />
      <ConversationCallButton :inbox="inbox" :chat="currentChat" />
      <!-- BonBoZ: gan the — dien thoai lay cho cua luoi the duoi khung chat. -->
      <NextButton
        v-if="laDienThoai"
        :aria-label="$t('BONBOZ.BANG_THE.NUT')"
        sm
        ghost
        slate
        icon="i-lucide-tag"
        class="relative rounded-md hover:bg-n-alpha-2"
        @click="bangTheDangMo = true"
      >
        <span
          v-if="soTheDaGan"
          class="grid absolute -top-0.5 place-items-center text-[10px] font-semibold leading-none text-white rounded-full ltr:-right-0.5 rtl:-left-0.5 size-4 bg-n-brand"
          aria-hidden="true"
        >
          {{ soTheDaGan }}
        </span>
      </NextButton>
      <!-- BonBoZ: nut bot duy nhat. Bat -> bot tra loi khach va khung soan tin
           khoa lai; bam lai -> bot im, hoi thoai ve tay nguoi truc.
           Nut PHAI nam ngoai khung soan tin: khi bot bat, khung do bi khoa, nut
           nam trong do thi khong con loi nao tat bot. -->
      <BotTestToggle v-if="hienNutBot" :conversation-id="currentChat.id" />
      <!-- BonBoZ: `aria-label` chu khong chi tooltip. Man cam ung khong ro chuot
           duoc nen tooltip khong bao gio hien, va nut chi con la mot bieu tuong
           tran — trinh doc man hinh cung khong doc duoc gi. -->
      <NextButton
        v-tooltip="$t('CONVERSATION_PARTICIPANTS.SIDEBAR_TITLE')"
        :aria-label="$t('CONVERSATION_PARTICIPANTS.SIDEBAR_TITLE')"
        sm
        ghost
        slate
        icon="i-lucide-users"
        class="rounded-md hover:bg-n-alpha-2"
        @click="toggleSidebar"
      />
      <MoreActions :conversation-id="currentChat.id" />
    </div>
    <BangGanThe
      v-if="laDienThoai"
      :dang-mo="bangTheDangMo"
      @dong="bangTheDangMo = false"
    />
  </div>
</template>
